import { Link } from "react-router-dom";

interface MovieCardProps {
  id: number;
  title: string;
  category: string;
  categoryLabel: string;
  rating: number;
  year: number;
  imageUrl: string;
  genre?: string;
  isHot?: boolean;
  isNew?: boolean;
}

export default function MovieCard({
  title,
  category,
  categoryLabel,
  rating,
  year,
  imageUrl,
  genre,
  isHot,
  isNew,
}: MovieCardProps) {
  return (
    <Link
      to={`/category/${category}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200 mb-3">
        <img
          src={imageUrl}
          alt={`${title} - ${categoryLabel}海报`}
          title={`${title} - 蜜桃影视${categoryLabel}推荐`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {(isHot || isNew) && (
          <div className="absolute top-2 left-2 flex gap-1">
            {isHot && (
              <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                热门
              </span>
            )}
            {isNew && (
              <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                新上
              </span>
            )}
          </div>
        )}

        <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-full bg-background-950/70 text-accent-400 text-xs font-semibold">
          <i className="ri-star-fill text-[10px]"></i>
          {rating}
        </div>
      </div>

      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
        {title}
      </h3>
      <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
        <span className="whitespace-nowrap">{year}</span>
        <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
        <span className="whitespace-nowrap">{categoryLabel}</span>
        {genre && (
          <>
            <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
            <span className="truncate whitespace-nowrap">{genre}</span>
          </>
        )}
      </div>
    </Link>
  );
}